const f = {}, g = {}, $ = [], c = {};
function R(s) {
  return Array.isArray(s) || typeof s == "object" && s !== null ? JSON.parse(JSON.stringify(s)) : s;
}
function p(s, e) {
  let t = s;
  if (s === null || typeof e != "string")
    return null;
  if (s[e])
    t = s[e];
  else {
    const r = e.toString().split(".");
    for (const n of r)
      if (t && typeof t == "object" && n in t)
        t = t[n];
      else
        return null;
  }
  return typeof t == "object" && t !== null ? R(t) : t ?? null;
}
function w() {
  return {
    hasCache(s, e) {
      return (c[`${s}:${e}`] ?? /* @__PURE__ */ new Map()).size > 0;
    },
    getCache(s, e) {
      return c[`${s}:${e}`];
    },
    setCache(s, e, t) {
      c[`${s}:${e}`] = t;
    },
    mergeTranslation(s, e, t, r = !1) {
      !r && !g[`${s}:${e}`] && console.error(`marge: route ${s}:${e} not loaded`), g[`${s}:${e}`] = {
        ...g[`${s}:${e}`],
        ...t
      };
    },
    mergeGlobalTranslation(s, e, t = !1) {
      !t && !f[`${s}`] && console.error(`marge: route ${s} not loaded`), f[s] = {
        ...f[s],
        ...e
      };
    },
    hasGeneralTranslation(s) {
      return !!f[s];
    },
    hasPageTranslation(s, e) {
      return !!g[`${s}:${e}`];
    },
    hasTranslation: (s, e) => {
      for (const t of $)
        if (p(t[s] || null, e) !== null)
          return !0;
      return p(f[s] || null, e) !== null;
    },
    getTranslation: (s, e, t) => {
      var a;
      const r = `${s}:${e}`, n = (a = c[r]) == null ? void 0 : a.get(t);
      if (n)
        return n;
      let i = null;
      for (const h of $)
        if (i = p(h[s] || null, t), i !== null) break;
      return i || (i = p(g[r] || null, t) ?? p(f[s] || null, t)), i && (c[r] || (c[r] = /* @__PURE__ */ new Map()), c[r].set(t, i)), i;
    },
    async loadPageTranslations(s, e, t) {
      const r = `${s}:${e}`;
      g[r] = { ...t };
    },
    async loadTranslations(s, e) {
      f[s] = { ...e };
    },
    clearCache() {
      Object.keys(f).forEach((s) => {
        f[s] = {};
      }), Object.keys(g).forEach((s) => {
        g[s] = {};
      }), $.length = 0, Object.keys(c).forEach((s) => {
        c[s].clear();
      });
    }
  };
}
function x(s, e) {
  let t = s;
  for (const r in e)
    t = t.split(`{${r}}`).join(String(e[r]));
  return t;
}
const m = (s) => s === "prefix" || s === "prefix_and_default", l = (s) => s === "no_prefix", T = (s) => s === "prefix", S = (s) => s === "prefix_except_default", N = (s) => s === "prefix_and_default";
class P {
  constructor(e, t, r, n, i, a) {
    this.i18nConfig = e, this.router = t, this.hashLocaleDefault = r, this.noPrefixDefault = n, this.navigateTo = i, this.setCookie = a;
  }
  getCurrentLocale(e) {
    var t;
    return e = e ?? this.router.currentRoute.value, this.i18nConfig.hashMode && this.hashLocaleDefault ? this.hashLocaleDefault : l(this.i18nConfig.strategy) && this.noPrefixDefault ? this.noPrefixDefault : (((t = e.params) == null ? void 0 : t.locale) ?? this.i18nConfig.defaultLocale).toString();
  }
  getCurrentName(e) {
    var n;
    const t = this.getCurrentLocale(e), r = (n = this.i18nConfig.locales) == null ? void 0 : n.find((i) => i.code === t);
    return (r == null ? void 0 : r.displayName) ?? null;
  }
  getRouteName(e, t) {
    return (e.name ?? "").toString().toString().replace("localized-", "").replace(new RegExp(`-${t}$`), "");
  }
  getFullPathWithBaseUrl(e, t) {
    let n = this.router.resolve(t).fullPath;
    e != null && e.baseDefault && (n = n.replace(new RegExp(`^/${e.code}`), ""));
    let i = e.baseUrl;
    return i || (i = ""), i != null && i.endsWith("/") && (i = i.slice(0, -1)), i + n;
  }
  switchLocaleRoute(e, t, r, n) {
    var y, v;
    const i = (y = this.i18nConfig.locales) == null ? void 0 : y.find((d) => d.code === t), a = this.getRouteName(r, e);
    if (this.router.hasRoute(`localized-${a}-${t}`)) {
      const d = { ...r.params ?? {}, ...n == null ? void 0 : n[t] };
      l(this.i18nConfig.strategy) || (d.locale = t);
      const C = {
        name: `localized-${a}-${t}`,
        params: d,
        query: r.query,
        hash: r.hash
      };
      return i != null && i.baseUrl ? this.getFullPathWithBaseUrl(i, C) : C;
    }
    let h = a;
    const o = { ...r.params ?? {}, ...n == null ? void 0 : n[t] };
    delete o.locale, l(this.i18nConfig.strategy) || (a === "custom-fallback-route" ? h = a : h = t !== this.i18nConfig.defaultLocale || m(this.i18nConfig.strategy) ? `localized-${a}` : a, l(this.i18nConfig.strategy) || (t !== this.i18nConfig.defaultLocale || m(this.i18nConfig.strategy)) && (o.locale = t));
    const u = {
      name: h,
      params: o,
      query: r.query,
      hash: r.hash
    };
    return l(this.i18nConfig.strategy) && ((v = this.i18nConfig.locales) == null || v.forEach((d, C) => {
      u.name.endsWith(`-${d.code}`) && (u.name = u.name.slice(0, -d.code - 1));
    })), i != null && i.baseUrl ? this.getFullPathWithBaseUrl(i, u) : u;
  }
  resolveParams(e) {
    const t = typeof e == "object" && "params" in e && typeof e.params == "object" ? { ...e.params } : {};
    if (typeof e == "string") {
      const r = this.router.resolve(e);
      r && r.params && Object.assign(t, r.params);
    }
    return t;
  }
  handlePrefixStrategy(e) {
    if (!m(this.i18nConfig.strategy))
      return e;
    const t = this.i18nConfig.defaultLocale;
    let r = e;
    typeof e == "string" && (r = this.router.resolve("/" + t + e));
    const n = this.getRouteName(r, t), i = this.resolveParams(r);
    return l(this.i18nConfig.strategy) || (i.locale = t), this.router.hasRoute(`localized-${n}`) ? this.router.resolve({
      name: `localized-${n}`,
      query: r.query,
      hash: r.hash,
      params: i
    }) : this.router.hasRoute(`localized-${n}-${t}`) ? this.router.resolve({
      name: `localized-${n}-${t}`,
      query: r.query,
      hash: r.hash,
      params: i
    }) : e;
  }
  createLocalizedRoute(e, t, r) {
    const n = this.router.resolve(e), i = this.getRouteName(n, r).replace(new RegExp(`-${this.i18nConfig.defaultLocale}$`), "");
    if (!l(this.i18nConfig.strategy) && (!i || i === "")) {
      let u = this.router.resolve(e).path.replace(new RegExp(`^/${r}/`), "/");
      return (r !== this.i18nConfig.defaultLocale || m(this.i18nConfig.strategy)) && (u = "/" + r + u), this.router.resolve({
        path: u,
        query: n.query,
        hash: n.hash
      });
    }
    if (this.router.hasRoute(`localized-${i}-${r}`)) {
      const o = this.resolveParams(n);
      return l(this.i18nConfig.strategy) || (o.locale = r), this.router.resolve({
        name: `localized-${i}-${r}`,
        params: o,
        query: n.query,
        hash: n.hash
      });
    }
    const a = r !== this.i18nConfig.defaultLocale || m(this.i18nConfig.strategy) ? `localized-${i}` : i;
    if (!this.router.hasRoute(a)) {
      const o = this.resolveParams(e);
      return delete o.locale, this.router.hasRoute(i) ? this.router.resolve({
        name: i,
        params: o,
        query: n.query,
        hash: n.hash
      }) : this.router.resolve("/");
    }
    const h = this.resolveParams(e);
    return delete h.locale, l(this.i18nConfig.strategy) || (r !== this.i18nConfig.defaultLocale || m(this.i18nConfig.strategy)) && (h.locale = r), this.router.resolve({
      name: a,
      params: h,
      query: n.query,
      hash: n.hash
    });
  }
  getLocalizedRoute(e, t, r) {
    const n = r || this.getCurrentLocale(t), i = this.handlePrefixStrategy(e);
    return this.createLocalizedRoute(i, t, n);
  }
  updateCookies(e) {
    this.i18nConfig.hashMode && (this.setCookie("hash-locale", e), this.hashLocaleDefault = e), l(this.i18nConfig.strategy) && (this.setCookie("no-prefix-locale", e), this.noPrefixDefault = e);
  }
  getCurrentRoute() {
    return this.router.currentRoute.value;
  }
  resolveRouteWithStrategy(e, t, r) {
    return l(this.i18nConfig.strategy) ? this.router.resolve(e) : t !== this.i18nConfig.defaultLocale || m(this.i18nConfig.strategy) ? this.router.resolve(`/${r}${e}`) : this.router.resolve(e);
  }
  switchLocaleLogic(e, t, r) {
    const n = this.getCurrentLocale();
    let i;
    typeof r == "string" ? i = this.resolveRouteWithStrategy(r, e, n) : i = r ?? this.getCurrentRoute(), this.updateCookies(e);
    const a = this.switchLocaleRoute(n, e, i, t);
    return typeof a == "string" && a.startsWith("http") ? this.navigateTo(a, { redirectCode: 200, external: !0 }) : (l(this.i18nConfig.strategy) && (a.force = !0), this.router.push(a));
  }
  resolveLocalizedRoute(e, t) {
    const r = this.getCurrentRoute(), n = this.getCurrentLocale(), i = t ?? n;
    let a;
    return typeof e == "string" ? (e.startsWith("/") || (e = `/${e}`), a = this.resolveRouteWithStrategy(e, i, n)) : a = e, this.getLocalizedRoute(a, r, i);
  }
}
class b {
  formatNumber(e, t, r) {
    return new Intl.NumberFormat(t, r).format(e);
  }
  formatDate(e, t, r) {
    const n = new Date(e);
    return Number.isNaN(n.getTime()) ? "Invalid Date" : new Intl.DateTimeFormat(t, r).format(n);
  }
  formatRelativeTime(e, t, r) {
    const n = new Date(e);
    if (Number.isNaN(n.getTime()))
      return new Intl.RelativeTimeFormat(t, r).format(0, "second");
    const a = Math.floor(((/* @__PURE__ */ new Date()).getTime() - n.getTime()) / 1e3), h = [
      { unit: "year", seconds: 31536e3 },
      { unit: "month", seconds: 2592e3 },
      { unit: "day", seconds: 86400 },
      { unit: "hour", seconds: 3600 },
      { unit: "minute", seconds: 60 },
      { unit: "second", seconds: 1 }
    ];
    for (const { unit: o, seconds: u } of h) {
      const y = Math.floor(a / u);
      if (y >= 1)
        return new Intl.RelativeTimeFormat(t, r).format(-y, o);
    }
    return new Intl.RelativeTimeFormat(t, r).format(0, "second");
  }
}
export {
  b as FormatService,
  P as RouteService,
  x as interpolate,
  l as isNoPrefixStrategy,
  N as isPrefixAndDefaultStrategy,
  S as isPrefixExceptDefaultStrategy,
  T as isPrefixStrategy,
  w as useTranslationHelper,
  m as withPrefixStrategy
};
